module.exports = __webpack_public_path__ + "img/6523.70c89068.jpg";